import { z } from "zod";

export const workerSchema = z.object({
	name: z.string().trim().min(1, { message: "Informe o nome da pessoa" }),
	jobTitle: z.string().trim(),
});

export type WorkerFormValues = z.infer<typeof workerSchema>;
